module.exports = __webpack_public_path__ + "static/mobile-blog-48c234dbf04fa8264a9cabe43e56357f.png";